export default "__VITE_ASSET__UeweNcfc__"